import applyUrlParams from './applyUrlParams';
export var createImgixBaseUrl = function createImgixBaseUrl(source, path) {
  var pathname = path.charAt(0) !== '/' ? "/".concat(path) : path;
  return "https://".concat(source, ".imgix.net").concat(pathname);
};
export var createImgixUrl = function createImgixUrl(source, path) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var baseUrl = createImgixBaseUrl(source, path);
  return applyUrlParams(baseUrl, options);
};